const navy = {
  50: "#E6E6EB",
  100: "#CFCFD9",
  200: "#A5A5B7",
  300: "#7E7E99",
  400: "#5E5E7F",
  500: "#030338",
  600: "#02022D",
  700: "#020222",
  800: "#010116",
  900: "#01010B",
};

const gray = {
  50: "#FBFBFB",
  100: "#F8F8F8",
  200: "#F1F1F1",
  300: "#EBEBEB",
  400: "#E6E6E6",
  500: "#D8D8D8",
  600: "#ADADAD",
  700: "#818181",
  800: "#565656",
  900: "#2B2B2B",
};

const pink = {
  50: "#FFECF0",
  100: "#FFDBE3",
  200: "#FFB9C9",
  300: "#FFB9C9",
  400: "#FF83A0",
  500: "#FF3D6B",
  600: "#CC3156",
  700: "#992540",
  800: "#66182B",
  900: "#330C15",
  chart: {
    50: "#D8D8D8",
    100: "#FFEDF2",
    200: "#FFD1DE",
    300: "#FFACC4",
    400: "#FF7EA3",
    500: "#FF5081",
  },
};

const cyan = {
  50: "#EDFAFD",
  100: "#DDF6FC",
  200: "#C0EDF9",
  300: "#A5E7F7",
  400: "#8EE0F5",
  500: "#4ECFEF",
  600: "#3EA5BF",
  700: "#2F7C8F",
  800: "#1F5360",
  900: "#102930",
};

const slate = {
  50: "#EFF1F3",
  100: "#E1E5E9",
  200: "#C5CDD5",
  300: "#ADB9C4",
  400: "#99A7B5",
  500: "#5F758B",
  600: "#4C5E6F",
  700: "#394653",
  800: "#262F38",
  900: "#13171C",
};

const green = {
  50: "#F0FBE9",
  100: "#E2F7D5",
  200: "#C9EFB0",
  300: "#B2E98F",
  400: "#9FE472",
  500: "#68D422",
  600: "#53AA1B",
  700: "#3E7F14",
  800: "#2A550E",
  900: "#152A07",
  chart: {
    50: "#D8D8D8",
    100: "#E9F5E0",
    200: "#D0EBBE",
    300: "#92C677",
    400: "#43A800",
    500: "#1E8C00",
  },
};

const orange = {
  50: "#FFF6E6",
  100: "#FFEECF",
  200: "#FFDEA3",
  300: "#FFD17D",
  400: "#FFC55C",
  500: "#FFA400",
  600: "#CC8300",
  700: "#996200",
  800: "#664200",
  900: "#332100",
};

const blue = {
  50: "#EEF2FF",
  100: "#DEE7FF",
  200: "#C0D2FF",
  300: "#A6BFFF",
  400: "#8FAFFF",
  500: "#5081FF",
  600: "#4067CC",
  700: "#304D99",
  800: "#203466",
  900: "#101A33",
  chart: {
    50: "#D8D8D8",
    100: "#EAF0FF",
    200: "#D3E0FF",
    300: "#6F97FF",
    400: "#5081FF",
    500: "#3570E3",
  },
};

// Not part of the rebranding color
const red = {
  50: "#FEEDF0",
  100: "#fad1d8",
  200: "#f5a2b2",
  300: "#f0748b",
  400: "#eb4565",
  500: "#E6173E", // (red)
  600: "#C51032",
  700: "#AA2E2E", // (darkRed)
  800: "#9B1B1D",
  900: "#851215",
};

// Not part of the rebranding color
const teal = {
  50: "#dcfff4",
  100: "#b2f9e4",
  200: "#87f5d4",
  300: "#59efc3",
  400: "#28EAB0", // (mint)
  500: "#14d199",
  600: "#06a377",
  700: "#007454",
  800: "#004732",
  900: "#00190f",
};

// Not part of the rebranding color
const whiteAlpha = {
  50: "rgba(255, 255, 255, 0.04)",
  100: "rgba(255, 255, 255, 0.06)",
  200: "rgba(255, 255, 255, 0.08)",
  300: "rgba(255, 255, 255, 0.16)",
  400: "rgba(255, 255, 255, 0.24)",
  500: "rgba(255, 255, 255, 0.36)",
  600: "rgba(255, 255, 255, 0.48)",
  700: "rgba(255, 255, 255, 0.64)",
  800: "rgba(255, 255, 255, 0.80)",
  900: "rgba(255, 255, 255, 0.92)",
};

const blackAlpha = {
  50: "rgba(0, 0, 0, 0.04)",
  100: "rgba(0, 0, 0, 0.06)",
  200: "rgba(0, 0, 0, 0.08)",
  300: "rgba(0, 0, 0, 0.16)",
  400: "rgba(0, 0, 0, 0.24)",
  500: "rgba(0, 0, 0, 0.36)",
  600: "rgba(0, 0, 0, 0.48)",
  700: "rgba(0, 0, 0, 0.64)",
  800: "rgba(0, 0, 0, 0.80)",
  900: "rgba(0, 0, 0, 0.92)",
};

export const colors = {
  navy,
  gray,
  pink,
  cyan,
  slate,
  green,
  orange,
  blue,
  red,
  teal,
  white: "#FCFCFC",
  black: "#030338",
  whiteAlpha,
  blackAlpha,
};

export const primaryColors = {
  black: colors.black,
  white: colors.white,
  pink: pink[500],
  cyan: cyan[500],
};

export const secondaryColors = {
  grey: slate[500],
  green: green[500],
  orange: orange[500],
  blue: blue[500],
};

export type ColorType = keyof typeof colors;
